import React from "react";
import _ from "lodash";
import { RadialGauge, LinearGauge } from "canvas-gauges";
import { Box, Grid, Typography } from "@material-ui/core";

const Test = React.memo(
  class GaugeRadial extends React.Component {
    componentDidMount() {
      this.setGauge();
    }
    componentDidUpdate() {
      this.setGauge();
    }

    setGauge() {
      const value = this.props.item;

      var tick = [];
      if (value.step !== "" && value.step !== 0) {
        var round = Math.round(value.max / value.step);
        for (var i = 1; i < round; i++) {
          if (i === 1) tick.push(value.min);
          var sum = Number(value.min) + Number(i * value.step);
          if (sum >= value.min && sum <= value.max) tick.push(sum);
        }

        if (Number(tick[_.size(tick) - 1]) !== Number(value.max)) {
          tick.push(value.max);
        }
      }

      const options = Object.assign(
        {},
        {
          title: value.name,
          units: value.unit,
          minValue: value.min,
          maxValue: value.max,
          value: this.props.value,
          valueInt: 1,
          majorTicks: tick,
          minorTicks: 5,
          strokeTicks: true,
          highlights: [
            {
              from: value.alert,
              to: value.max,
              color: "rgba(200, 50, 50, .75)",
            },
            {
              from: value.min,
              to: value.low_alert,
              color: "rgba(245, 215, 110, .75)",
            },
          ],
          colorPlate: "white",
          borderShadowWidth: 0,
          borders: false,
          needleType: "arrow",
          needleWidth: 2,
          needleCircleSize: 7,
          needleCircleOuter: true,
          needleCircleInner: false,
          animationDuration: 1500,
          animationRule: "linear",
          fontTitleSize: 25,
        },
        {
          renderTo: this.el,
        }
      );
      switch (value.gauge_type) {
        case "Boiler pressure":
          options.width = 260;
          options.height = 260;
          this.gauge = new RadialGauge(options).draw();
          break;
        case "Flue gas temp.":
          options.width = 260;
          options.height = 260;
          options.colorPlate = "black";
          options.colorMajorTicks = "white";
          options.colorMinorTicks = "white";
          options.colorNumbers = "white";
          options.colorTitle = "white";
          options.colorUnits = "white";
          options.colorBorderOuter = "white";
          options.colorBorderOuterEnd = "white";
          options.borderOuterWidth = 2;
          options.borders = true;
          this.gauge = new RadialGauge(options).draw();
          break;
        case "Boiler level":
          options.width = 130;
          options.height = 350;
          options.colorPlate = "black";
          options.colorMajorTicks = "#ffbf00";
          options.colorMinorTicks = "#ffbf00";
          options.colorNumbers = "white";
          options.colorBarProgress = "#0080ff";
          options.barWidth = "10";
          this.gauge = new LinearGauge(options).draw();
          break;
        case "Oil Flow meter":
          options.width = 260;
          options.height = 260;
          options.startAngle = 30;
          options.ticksAngle = 150;
          options.borders = true;
          options.colorBorderOuter = "rgba(10,49,255,1)";
          options.colorBorderOuterEnd = "rgba(2,2,2,1)";
          options.borderOuterWidth = 15;
          options.highlights = [
            {
              from: value.alert,
              to: value.max,
              color: "rgba(169,169,169,1)",
            },
            {
              from: value.low_alert,
              to: value.max,
              color: "rgba(169,169,169,0.5)",
            },
          ];
          this.gauge = new RadialGauge(options).draw();
          break;
        case "FW tank level":
          options.width = 130;
          options.height = 350;
          this.gauge = new LinearGauge(options).draw();
          break;
        case "FW tank temp.":
          options.width = 130;
          options.height = 350;
          this.gauge = new LinearGauge(options).draw();
          break;
        case "Steam flow meter":
          options.width = 260;
          options.height = 260;
          options.startAngle = 180;
          options.ticksAngle = 360;
          options.majorTicks = [...tick, "0"];
          options.borders = true;
          options.colorBorderOuter = "rgba(150,150,150,1)";
          options.colorBorderOuterEnd = "rgba(2,2,2,1)";
          options.borderOuterWidth = 15;
          options.highlights = [
            {
              from: value.alert,
              to: value.max,
              color: "rgba(169,169,169,1)",
            },
            {
              from: value.low_alert,
              to: value.max,
              color: "rgba(169,169,169,0.5)",
            },
          ];
          this.gauge = new RadialGauge(options).draw();
          break;
        case "nogauge":
          break;
        default:
          options.width = 260;
          options.height = 260;
          this.gauge = new RadialGauge(options).draw();
      }
    }
    render() {
      return (
        <div className="relative flex flex-col w-full justify-center items-center">
          {this.props.item.gauge_type === "nogauge" ? (
            <Box
              mr={1}
              mb={1}
              pb={3}
              width={{ xs: "70vw", md: "97%" }}
              height="300px"
              borderRadius="6px"
            >
              <Grid item xs={12}>
                <div
                  className="flex w-full flex-col justify-center items-center h-64"
                  style={{ color: "#303030" }}
                >
                  <p className="text-5xl text-center font-bold text-secondary">
                    {this.props.value ? this.props.value : "000"}
                  </p>
                  <p className="text-3xl text-center text-secondary">
                    {this.props.item.unit}
                  </p>
                </div>
              </Grid>
            </Box>
          ) : (
            <canvas
              ref={(canvas) => {
                this.el = canvas;
              }}
            />
          )}
        </div>
      );
    }
  }
);

export default Test;
